import PublicRoutes from './PublicRoutes'

export default PublicRoutes
